<script setup lang="ts">
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import { useTheme } from '../theme/useTheme'

const { t } = useI18n()
const { mode, cycleMode } = useTheme()

const icons: Record<string, string> = { light: '☀', dark: '☾', system: '◐' }
const icon = computed(() => icons[mode.value] ?? '◐')
const label = computed(() => t('theme.toggle', { mode: t(`theme.${mode.value}`) }))
</script>

<template>
  <button
    type="button"
    class="theme-switcher"
    :title="label"
    :aria-label="label"
    @click="cycleMode"
  >
    <span class="icon" aria-hidden="true">{{ icon }}</span>
    <span class="name">{{ t(`theme.${mode}`) }}</span>
  </button>
</template>
